"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FREE_STARBUCKS_GIFT_CARD_VALUE_DOLLARS = exports.AvenMyFreeWeeklyStarbucksCardStatus = void 0;
var AvenMyFreeWeeklyStarbucksCardStatus;
(function (AvenMyFreeWeeklyStarbucksCardStatus) {
    AvenMyFreeWeeklyStarbucksCardStatus["CAN_CLAIM_NOW"] = "CAN_CLAIM_NOW";
    AvenMyFreeWeeklyStarbucksCardStatus["COUNTDOWN"] = "COUNTDOWN";
    AvenMyFreeWeeklyStarbucksCardStatus["CLAIMED_ALL_STARBUCKS"] = "CLAIMED_ALL_STARBUCKS";
    AvenMyFreeWeeklyStarbucksCardStatus["HIDDEN"] = "HIDDEN";
})(AvenMyFreeWeeklyStarbucksCardStatus || (exports.AvenMyFreeWeeklyStarbucksCardStatus = AvenMyFreeWeeklyStarbucksCardStatus = {}));
exports.FREE_STARBUCKS_GIFT_CARD_VALUE_DOLLARS = 5;
